var forms = {};

//ACTIONS
forms.actions = function(actions){
	var $form = actions.closest('form');
	function isLast($element) {
		var $ignoreTags 	= ['LINK', 'SCRIPT', 'STYLE'];
		var $ignoreClass 	= ['modal'];
		var $latest			= true;

		$element.nextAll().each(function(i){
			var $tag = $(this);

			if($ignoreTags.indexOf($tag.prop('tagName')) < 0)
			{
				$tag.attr('data-invalid', '1');

				if($tag.is('[class]'))
				{
					$.each($tag.attr('class').split(' '), function(i, v){
						if($ignoreClass.indexOf(v) != -1)
						{
							$tag.removeAttr('data-invalid');
							return false;
						}
					});
				}
			}

			if((i + 1 === $element.nextAll().length) && ($element.nextAll('[data-invalid]').length))
			{
				$element.nextAll('[data-invalid]').removeAttr('data-invalid');
				$latest = false;
			}
		});

		return $latest;
	}

	if(isLast(actions) && isLast($form))
	{
		$form.addClass('is-last');

		if($form.hasClass('fix-actions'))
		{
			var $fixed 	= false;
			var $viewBottom = $(window).scrollTop() + $(window).height();

			actions.addClass(function(){
				return $viewBottom <= (actions.offset().top - $(window).height()) ? 'fade' : 'fade show';
			});

			$(window).on('scroll',function(e){
				var $from 		= $form.offset().top;
				var $to 		= $from + ($form.outerHeight() - $(window).height());
				var $scrollTop  = $(window).scrollTop();

				if($scrollTop >= $from && $scrollTop <= $to)
				{
					if(!$fixed)
					{
					    actions.css({
					    	'left' : function(){
					    		return actions.offset().left + 'px';
						    },
						    'width' : function(){
					    		return actions.outerWidth() + 'px';
						    }
					    })
					    .addClass('position-fixed show');
					    $form.css('padding-bottom', actions.outerHeight() + 'px');
						$fixed = true;
					}
				}
				else if($fixed)
				{
					actions.css({
				    	'left' : '',
					    'width' : ''
				    })
				    .removeClass('position-fixed');
					$form.css('padding-bottom', '');
					$fixed = false;

					if($scrollTop < $from)
					{
						actions.removeClass('show');
					}
				}
			})
			.trigger('scroll');
		}
	}
}

//CHAR COUNT
forms.charCount = {};
forms.charCount.init = function(input){
	input.on('keyup', function (){
		var $length = $(this).val().length;
		var $max 	= $(this).attr('data-max-length');
		var $target	= input.next('.char-count').find('span');

		if($length > $max)
			$target.addClass('text-danger');
		else
			$target.removeClass('text-danger');

		$target.text($length);

	})
	.trigger('keyup');
}

//COLOR
forms.color = {
    customThemeVariationColors: null,
    colorpickerPalette: null,
    colorpickerDefaultPalette: [
        ["#000000","#444444","#5b5b5b","#999999","#bcbcbc","#eeeeee","#f3f6f4","#ffffff"],
        ["#f44336","#744700","#ce7e00","#8fce00","#2986cc","#16537e","#6a329f","#c90076"],
        ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
        ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
        ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
        ["#cc0000","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
        ["#990000","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
        ["#660000","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
    ]
};

forms.color.getCustomThemeVariationColors = function() {
    if (forms.color.customThemeVariationColors !== null) {
        return forms.color.customThemeVariationColors;
    }

    var response = $.ajax({
        url: window.site_url + 'site/design/getCustomThemeVariationColors',
        dataType: 'json',
        type: 'GET',
        async: false
    });

    if (response.statusText !== 'OK') {
        console.error('Can\'t fetch custom theme variation colors !');
        forms.color.customThemeVariationColors = {};
    }

    try {
        forms.color.customThemeVariationColors = $.parseJSON(response.responseText);
    } catch (err) {
        forms.color.customThemeVariationColors = [];
    }

    return forms.color.customThemeVariationColors;
};

forms.color.getColorpickerPalette = function() {
    if (forms.color.colorpickerPalette !== null) {
        return forms.color.colorpickerPalette;
    }

    var customThemeVariationColors = forms.color.getCustomThemeVariationColors();
    var extraPalette = [];

    for (var colorIndex in customThemeVariationColors) {
        var color = customThemeVariationColors[colorIndex];
        if ($.inArray(color, extraPalette) === -1) {
            extraPalette.push(color);
        }
    }

    forms.color.colorpickerPalette = forms.color.colorpickerDefaultPalette;

    if (extraPalette.length > 0) {
        forms.color.colorpickerPalette.push(extraPalette);
    }

    return forms.color.colorpickerPalette;
}

forms.color.init = function(field) {
    field.find('input[type="text"]').each(function (index, el) {
        $(el).attr('autocomplete', 'off');
        $(el).addClass('form-control');

        var color = null;
        var allowEmpty = true;

        if ($(this).parents('.is_color_preview:first').attr('data-default') !== undefined) {
            color = $(this).parents('.is_color_preview:first').attr('data-default')
            allowEmpty = false;
        }

        var storageKey = null;
        if (window.site !== undefined) {
            storageKey = 'spectrum.site-' + window.site.id;
        }

        $(el).spectrum({
            showButtons: false,
            showInitial: true,
            allowEmpty: allowEmpty,
            color: color,
            preferredFormat: "rgb",
            showAlpha: true,
            clickoutFiresChange: true,
            palette: forms.color.getColorpickerPalette(),
            localStorageKey: storageKey,
            hideAfterPaletteSelect: true,
            change: function (color) {
                // event compatibility in themes manager js (in database !)
                $(el).trigger('changeColor.colorpicker', [color]);

                // Handle default color on "no color" select
                if (color === null) {
                    // event compatibility in themes manager js (in database !)
                    $(el).trigger('resetColor.colorpicker', [color]);

                    if ($(this).parents('.is_color_preview:first').attr('data-default') !== undefined) {
                        color = $(this).parents('.is_color_preview:first').attr('data-default')
                        $(this).spectrum('set', color);
                        return;
                    }
                }

                let code = null;

                if (color !== null) {
                    let rgba = color.toRgb();
                    code = 'rgba(' + rgba['r'] + ', ' + rgba['g'] + ', ' + rgba['b'] + ', ' + rgba['a'] + ')';
                }

                    // Handle target element color
                if ($(this).parents('.is_color_preview:first').attr('data-target') !== undefined) {
                    let target = $(this).parents('.is_color_preview:first').attr('data-target');
                    let rule = 'color';

                    if ($(this).parents('.is_color_preview:first').attr('data-rule') !== undefined) {
                        rule = $(this).parents('.is_color_preview:first').attr('data-rule');
                    }

                    if (code !== null) {
                        $(target).css(rule, code);
                    } else {
                        $(target).css(rule, '');
                    }
                }

                if (color !== null) {
                    field.attr('value', code);
                } else {
                    field.attr('value', '');
                }

                // var $rgba = color.toRgb();
                //
                // field.find('i').toggleClass('nocolor', $settings.reset).css('background-color', function() {
                //     return $settings.reset ? '' : $code;
                // });
                //
                // if($settings.reset)
                // {
                //     $settings.input.val('');
                //     $settings.reset = false;
                // }
                //
                // if($settings.target)
                // {
                //     $($settings.target).css($settings.rule, function(){
                //         return $settings.reset ? '' : $code;
                //     });
                // }
            }
        });
    });

	// var $settings 	= {
	// 	'default'		: false,
	// 	'input'			: field.find('[type="text"]'),
	// 	'id' 			: field.find('[type="text"]').attr('id'),
	// 	'format' 		: 'rgba',
	// 	'reset'			: false,
	// 	'target'		: false,
	// 	'rule'			: 'color'
	// }
	//
	// $.extend($settings, field.data());
	//
	// if($settings.target)
	// {
	// 	$($settings.target.replace(/([\[\]])/g, '\\$1')).css($settings.rule, $settings.input.val());
	// }
	//
	// field.colorpicker({
	// 	format: $settings.format,
	// 	horizontal: true,
	// 	template: '<div class="colorpicker dropdown-menu">' +
	// 		'<div class="colorpicker-saturation"><i><b></b></i></div>' +
	// 		'<div class="colorpicker-hue"><i></i></div>' +
	// 		'<div class="colorpicker-alpha"><i></i></div>' +
	// 		'<div class="colorpicker-color"><div /></div>' +
	// 		'<div class="colorpicker-empty">' +
	// 			'<button type="button" class="btn btn-sm btn-block" data-cpid="' + $settings.id + '">' + doc.langLine('none_f') + '</button>' +
	// 		'</div>' +
	// 	'</div>'
	// })
	// .on({
	// 	'changeColor.colorpicker' : function(e){
	// 		var $rgba	= e.color.toRGB();
	// 		var $code 	= $settings.format == 'rgba' ? 'rgba(' + $rgba['r'] + ',' + $rgba['g'] + ',' + $rgba['b'] + ',' + $rgba['a'] + ')' : 'rgb(' + $rgba['r'] + ',' + $rgba['g'] + ',' + $rgba['b'] + ')';
	//
	// 		field.find('i').toggleClass('nocolor', $settings.reset).css('background-color', function(){
	// 			return $settings.reset ? '' : $code;
	// 		});
	//
	// 		if($settings.reset)
	// 		{
	// 			$settings.input.val('');
	// 			$settings.reset = false;
	// 		}
	//
	// 		if($settings.target)
	// 		{
	// 			$($settings.target).css($settings.rule, function(){
	// 				return $settings.reset ? '' : $code;
	// 			});
	// 		}
	// 	},
	// 	'create.colorpicker' : function(e){
	// 		if($settings.default && !$settings.input.val())
	// 		{
	// 			$settings.input.val($settings.default);
	// 			field.colorpicker('setValue', $settings.default);
	// 		}
	// 	},
	// 	'resetColor.colorpicker' : function(e){
	// 		if($settings.default)
	// 		{
	// 			$settings.input.val($settings.default);
	// 			var $defaultColor = $settings.default;
	// 		}
	// 		else
	// 		{
	// 			$settings.reset = true;
	// 			var $defaultColor = $settings.format === 'rgba' ? 'rgba(0,0,0,1)' : 'rgb(0,0,0)';
	// 		}
	// 		field.colorpicker('setValue', $defaultColor);
	// 	}
	// });
};
forms.color.update = function(id, color){
    if(color != '') {
        $('#' + id).spectrum('set', color);
    } else {
        forms.color.reset(id);
    }
};
forms.color.reset = function(id){
	$('#' + id.replace('.','\\.')).each(function(index, el) {
	    let color = '';

        // Handle default color on "no color" select
        if ($(el).parents('.is_color_preview:first').attr('data-default') !== undefined) {
            color = $(el).parents('.is_color_preview:first').attr('data-default')
        }

        $(el).spectrum('set', color);
    });
};

//DATES
forms.date = {};
forms.date.init = function(handler){
	var $id		= handler.attr('id');
	var $label 	= $('[for="' + $id + '"]').length === 1 ? $('[for="' + $id + '"]') : null;

	handler.datepicker({
		format		: 'yyyy-mm-dd',
		language	: site.default_lang
	})
	.on({
		'changeDate' : function(ev){
			var $day 	= ev.date.getUTCDate();
			var $month 	= ev.date.getUTCMonth() + 1;
			var $year 	= ev.date.getUTCFullYear();
			$('#' + $id + '_d').val($day);
			$('#' + $id + '_m').val($month);
			$('#' + $id + '_y').val($year);

			handler.datepicker('hide');
		},
		'hide' : function(){
			$('.datepicker.top').removeClass('top');
		}
	});

	handler.closest('.date-inputs').find('select, input[type="number"]').each(function(){
		$(this)
		.on({
			'change' : function(){
				var $date = $('#' + $id + '_y').val() + '-' + $('#' + $id + '_m').val() + '-' + $('#' + $id + '_d').val();

				if(forms.date.ckeckFormat($date))
				{
					handler.datepicker('update', $date);
				}
			}
		});
	});
};
forms.date.ckeckFormat = function(stringDate){
	if(stringDate.length === 10)
	{
		var $d   			= parseInt(stringDate.substring(0,2));
		var $mon  			= parseInt(stringDate.substring(3,5));
		var $yr   			= parseInt(stringDate.substring(6,10));
		var $date 			= new Date($yr, $mon - 1, $d);
		var $convertedDate	= new Date($date.getFullYear(), $date.getMonth(), $date.getDate());
		return $convertedDate;
	}
	return false;
};

//EXPLORER BTN
forms.explorerBtn = {};
forms.explorerBtn.init = function(dom){
	var $preview = dom.find('img').length != 0;
	var $type = dom.is('[data-type]') ? dom.attr('data-type') : 'image';
	var $content = $type === 'file' ? dom.is('[data-content]') ? dom.attr('data-content') : 'video' : null;
	var $handler = dom.find('.explorer-btn-add').length ? dom.find('.explorer-btn-add') : dom;

	dom.data({
		'content': $content,
		'preview': $preview,
		'type': $type
	});
	$handler.bind('click', $.proxy(forms.explorerBtn, 'add', dom))

	if($preview)
	{
		var $empty = dom.find('img[src=""]').length ? true : false;
		dom.find('.img-expanded').toggleClass('d-none', $empty);
		dom.find('.explorer-btn-remove').bind('click', $.proxy(forms.explorerBtn, 'remove', dom));
	}
};
forms.explorerBtn.add = function(dom, e){
	this.dom = dom;

	var $callback = $.proxy(this, 'onSelect');

  var context = dom.hasClass('explorer-btn-product-picture') ? 'productpics' : 'default';

	if(dom.data('type') === 'image')
	{
		window.stoManager.selectImage($callback, false, context);
	}
	else
	{
		window.stoManager.selectFile($callback, false, dom.data('content') === 'video');
	}
};
forms.explorerBtn.remove = function(dom){
	dom.find('.explorer-file-id').val('');
	dom.find('.explorer-file-url').val('');

	if(dom.data('preview'))
	{
		dom.find('.img-expanded img').attr('src', '').closest('.img-expanded').addClass('d-none');
	}

	dom.trigger('onRemove');
}
forms.explorerBtn.onSelect = function(options){
  if (Array.isArray(options)){
    this.dom.data({
      'images' : JSON.stringify(options)
    })
      .trigger('onSelect');
  } else {
    if(this.dom.data('type') == 'image'){
      var $id = options.image.id;
      var $url = options.image.url;

      // replace src with manager proxy url if necessary
      // if (window.doc.brand.protocol === 'https' && window.site.protocol === 'http') {
      //   var matches = $url.match('^' + window.site.protocol + '://' + window.site.host + '/medias/images/(.*)$');
      //   if (matches) {
      //     $url = window.doc.brand.protocol + '://manager.' + window.doc.brand.technical_domain + '/storage/image/' + matches[1];
      //   }
      // }

      var $src = $url + '?fx=c_120_120';
    }
    else
    {
      var $id = options.file.id;
      var $url = options.file.url;
      var $src = window.file_url + 'fileicon/' + options.file.extension + '.png';
    }
    this.dom.find('.explorer-file-id').val($id);
    this.dom.find('.explorer-file-url').val($url);

    if(this.dom.data('preview'))
    {
      this.dom.find('.img-expanded img').attr('src', $src).closest('.img-expanded').removeClass('d-none');
    }

    var $doc = window.document;
    var mediaFacebook = $doc.getElementById('meta-media-facebook');
    var mediaTwitter = $doc.getElementById('meta-media-twitter');
    var mediaLinkedin = $doc.getElementById('meta-media-linkedin');
    var googleImg = $doc.getElementById('google-img');

    if (mediaFacebook) {
      $doc.getElementById('meta-media-facebook').style['background-image'] ='url("'+$url+'")';
    }

    if (mediaTwitter) {
      $doc.getElementById('meta-media-twitter').style['background-image'] ='url("'+$url+'")';
    }

    if (mediaLinkedin) {
      $doc.getElementById('meta-media-linkedin').style['background-image'] ='url("'+$url+'")';
    }

    if (googleImg) {
      $doc.getElementById('google-img').setAttribute('src', $url);
      $doc.getElementById('google-img').classList.remove('d-none');
    }


    this.dom.data({
      'id' : $id,
      'url' : $url,
      'images' : ''
    })
      .trigger('onSelect');
  }
};

//FILE INPUTS
forms.fileInput = {};
forms.fileInput.init = function(input){
	input.wrap('<div class="btn-group btn-group-file"><label ' + (input.is('[id]') ? 'for="' + input.attr('id') + '" ' : '') + 'class="btn btn-light"></label></div>').after('<span class="btn-label"/></span>');
	input.on({
		'change blur' : function(){
			$(this).closest('label').toggleClass('is-empty', !$(this).val());
			var $label = $(this).val() ? $(this).val().split('\\')[$(this).val().split('\\').length - 1] : '<i class="fa fa-upload"></i>' + doc.langLine('file');
			$(this).next('.btn-label').html($label);
		}
	})
	.trigger('change');

	var $btn = $('<button class="btn btn-danger"><i class="fa fa-times"></i></button>').on('click', function(e){
		e.preventDefault();
		input.val('').trigger('change');
	});
	input.closest('label').after($btn);
};

//RANGE
forms.range = {};
forms.range.init = function(input){
	var $target = $(input.attr('data-target'));
	input.on({
		'change mousedown mousemove' : function(e){
			e.stopPropagation();
			$target.val($(this).val());
		}
	});
	$target.on('change', function(e){
		e.stopPropagation();
		input.val($(this).val());
	});
};

//TEXTAREAS
forms.textarea = {};
forms.textarea.init = function(input){
	var $label = $('[for="' + input.attr('id') + '"]').length === 1 ? $('[for="' + input.attr('id') + '"]') : null;
	input.on({
		'change' : function(){
			$(this).css('height', ($(this)[0].scrollHeight + 2) + 'px');
		},
		'cut paste drop keydown keyup' : function(){
			$(this).trigger('change');
		}
	})
	.trigger('blur');
};

//SELECT MULTIPLE
forms.multiselect = {};
forms.multiselect.resize = function(select){
	select.css({
		'top' : select.next('.multiselect').position().top,
		'left' : select.next('.multiselect').position().left,
		'width' : select.next('.multiselect').width(),
		'height' : select.next('.multiselect').height()
	});
};

/* =============================================================
 * bootstrap-typeahead.js v2.2.1
 * http://twitter.github.com/bootstrap/javascript.html#typeahead
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */
!function($){

  "use strict"; // jshint ;_;


 /* TYPEAHEAD PUBLIC CLASS DEFINITION
  * ================================= */

  var Typeahead = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.typeahead.defaults, options)
    this.matcher = this.options.matcher || this.matcher
    this.sorter = this.options.sorter || this.sorter
    this.highlighter = this.options.highlighter || this.highlighter
    this.updater = this.options.updater || this.updater
    this.$menu = $(this.options.menu).appendTo('body')
    this.source = this.options.source
    this.shown = false
    this.$element.attr('autocomplete', 'off')
    this.listen()
  }

  Typeahead.prototype = {

    constructor: Typeahead

  , select: function () {
      var val = this.$menu.find('.active').attr('data-value')
      this.$element
        .val(this.updater(val))
        .change()
      return this.hide()
    }

  , updater: function (item) {
      return item
    }

  , show: function () {
      var pos = $.extend({}, this.$element.offset(), {
        height: this.$element[0].offsetHeight
      })

      this.$menu.css({
        top: pos.top + pos.height
      , left: pos.left
      })

      this.$menu.show()
      this.shown = true
      return this
    }

  , hide: function () {
      this.$menu.hide()
      this.shown = false
      return this
    }

  , lookup: function (event) {
      var items

      this.query = this.$element.val()

      if (!this.query || this.query.length < this.options.minLength) {
        return this.shown ? this.hide() : this
      }

      items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

      return items ? this.process(items) : this
    }

  , process: function (items) {
      var that = this

      items = $.grep(items, function (item) {
        return that.matcher(item)
      })

      items = this.sorter(items)

      if (!items.length) {
        return this.shown ? this.hide() : this
      }

      return this.render(items.slice(0, this.options.items)).show()
    }

  , matcher: function (item) {
      return ~item.toLowerCase().indexOf(this.query.toLowerCase())
    }

  , sorter: function (items) {
      var beginswith = []
        , caseSensitive = []
        , caseInsensitive = []
        , item

      while (item = items.shift()) {
        if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
        else if (~item.indexOf(this.query)) caseSensitive.push(item)
        else caseInsensitive.push(item)
      }

      return beginswith.concat(caseSensitive, caseInsensitive)
    }

  , highlighter: function (item) {
      var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
      return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
        return '<strong>' + match + '</strong>'
      })
    }

  , render: function (items) {
      var that = this

      items = $(items).map(function (i, item) {
        i = $(that.options.item).attr('data-value', item)
        i.find('a').html(that.highlighter(item))
        return i[0]
      })

      items.first().addClass('active')
      this.$menu.html(items)
      return this
    }

  , next: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , next = active.next()

      if (!next.length) {
        next = $(this.$menu.find('li')[0])
      }

      next.addClass('active')
    }

  , prev: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , prev = active.prev()

      if (!prev.length) {
        prev = this.$menu.find('li').last()
      }

      prev.addClass('active')
    }

  , listen: function () {
      this.$element
        .on('blur',     $.proxy(this.blur, this))
        .on('keypress', $.proxy(this.keypress, this))
        .on('keyup',    $.proxy(this.keyup, this))

      if (this.eventSupported('keydown')) {
        this.$element.on('keydown', $.proxy(this.keydown, this))
      }

      this.$menu
        .on('click', $.proxy(this.click, this))
        .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
    }

  , eventSupported: function(eventName) {
      var isSupported = eventName in this.$element
      if (!isSupported) {
        this.$element.setAttribute(eventName, 'return;')
        isSupported = typeof this.$element[eventName] === 'function'
      }
      return isSupported
    }

  , move: function (e) {
      if (!this.shown) return

      switch(e.keyCode) {
        case 9: // tab
        case 13: // enter
        case 27: // escape
          e.preventDefault()
          break

        case 38: // up arrow
          e.preventDefault()
          this.prev()
          break

        case 40: // down arrow
          e.preventDefault()
          this.next()
          break
      }

      e.stopPropagation()
    }

  , keydown: function (e) {
      this.suppressKeyPressRepeat = !~$.inArray(e.keyCode, [40,38,9,13,27])
      this.move(e)
    }

  , keypress: function (e) {
      if (this.suppressKeyPressRepeat) return
      this.move(e)
    }

  , keyup: function (e) {
      switch(e.keyCode) {
        case 40: // down arrow
        case 38: // up arrow
        case 16: // shift
        case 17: // ctrl
        case 18: // alt
          break

        case 9: // tab
        case 13: // enter
          if (!this.shown) return
          this.select()
          break

        case 27: // escape
          if (!this.shown) return
          this.hide()
          break

        default:
          this.lookup()
      }

      e.stopPropagation()
      e.preventDefault()
  }

  , blur: function (e) {
      var that = this
      setTimeout(function () { that.hide() }, 150)
    }

  , click: function (e) {
      e.stopPropagation()
      e.preventDefault()
      this.select()
    }

  , mouseenter: function (e) {
      this.$menu.find('.active').removeClass('active')
      $(e.currentTarget).addClass('active')
    }

  }


  /* TYPEAHEAD PLUGIN DEFINITION
   * =========================== */

  $.fn.typeahead = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('typeahead')
        , options = typeof option == 'object' && option
      if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.typeahead.defaults = {
    source: []
  , items: 8
  , menu: '<ul class="typeahead dropdown-menu"></ul>'
  , item: '<li><a href="#" class="dropdown-item"></a></li>'
  , minLength: 1
  }

  $.fn.typeahead.Constructor = Typeahead


 /*   TYPEAHEAD DATA-API
  * ================== */

  $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
    var $this = $(this)
    if ($this.data('typeahead')) return
    e.preventDefault()
    $this.typeahead($this.data())
  })

}(window.jQuery);

import {MaterialIconsSelector} from "./components/forms/icon-selector/material-icons-selector";
import {FontAwesomeSelector} from "./components/forms/icon-selector/font-awesome-selector";
import {FontSelector} from "./components/forms/font-selector/font-selector";
import {NumericStepper} from "./components/forms/numeric-stepper/numeric-stepper";

$.fn.iconSelector = function(options) {
    return this.each(function() {
        if ((options !== undefined && 'iconSet' in options)) {
            var iconSet = options.iconSet;
        } else if ($(this).attr('data-set') !== undefined && $(this).attr('data-set') !== false) {
            var iconSet = $(this).attr('data-set');
        } else {
            throw 'no data-set attribute or iconSet option found';
        }

        switch (iconSet) {
            case 'material-icons':
                var iconSelector = new MaterialIconsSelector(this, options);
                break;

            case 'font-awesome':
                var iconSelector = new FontAwesomeSelector(this, options);
                break;

            default:
                throw 'unknown icon set';
        }

        iconSelector.init();

        $(this).data('iconSelector', iconSelector);
    });
};

$.fn.fontSelector = function(options) {
    return this.each(function() {
        $(this).data('fontSelector', new FontSelector(this, options));
    });
};

$.fn.numericStepper = function(options) {
    return this.each(function() {
        new NumericStepper(this);
    });
};

forms.init = function(){

	//ACTIONS
	$('#contenu').find('form:last-of-type').find('.form-actions').each(function(){
		forms.actions($(this));
	});

	//CHARCOUNT
	$('[data-max-length]').each(function(){
		forms.charCount.init($(this));
	});

	//COLOR
	$('.is_color_preview').each(function(){
		forms.color.init($(this));
	});
	$('.colorpicker-empty').find('button').on('click', function(){
		forms.color.reset($(this).data('cpid'));
	});

	//DATES
	$('.js-show-calendar').each(function(){
		forms.date.init($(this));
	});

	//EXPLORER BTN
	$('.explorer-btn').each(function (){
		forms.explorerBtn.init($(this));
	});

	//FILES INPUT
	$('input[type="file"]').each(function(){
		forms.fileInput.init($(this));
	});

	//RANGE
	$('input[type="range"][data-target]').each(function(){
		forms.range.init($(this));
	});

	//NUMERIC STEPPER
  $('[data-provide="numeric-stepper"]').each(function() {
    $(this).numericStepper();
  });

	//AUTOCOMPLETER
  $('[data-provide="autocompleter"]').each(function() {
    $(this).autocompleter($(this).data());
  });

	//TEXTAREA
	$('textarea').each(function(){
		forms.textarea.init($(this));
	});

	//SELECT MULTIPLE
	$('.js-multiselect').each(function(){
		doc.initMultiselect($(this));
	});

	//ICONS SELECTOR
  $('[data-provide="icons-selector"]').each(function() {
    $(this).iconSelector();
  });

	//FONT SELECTOR
  var fonts = [];

  if ('site' in window && window.site !== null) {
    window.site.googlefont.forEach((value) => {
      fonts.push({
        label: value,
        value
      });
    });
  }

  $('[data-provide="font-selector"]').each(function() {
    $(this).fontSelector({fonts});
  });

  $('.radioImage').each(function() {
    $(this).find('input[type="radio"]').each(function() {
      $(this).addClass('d-none');
    });

    $(this).find('label').each(function() {
      $(this).addClass('d-none');
    });
  });

  $('.radioImage img.choice-label').on('click', function() {
    if ($(this).hasClass('selected')) {
      if ($(this).data('notdesactivable') == 0) {
        $(this).removeClass('selected');
        $(this).siblings('input[type="radio"]').prop('checked', false);

        $('.radioImage > .form-check').first().find('input[type="radio"]').prop('checked', true);
      }
    } else {
      var modifyField = $(this).data('field');

      $('img.illustrated-radio-img').each(function() {
        if ($(this).data('field') == modifyField) {
          $(this).removeClass('selected');
        }
      });

      $(this).addClass('selected');
      $(this).siblings('input[type="radio"]').prop('checked', true);
    }
  });

};

window.forms = forms;
